import React from 'react'
import SettingsSavePanel from './SettingsSavePanel'

/**
 * Обёртка для страниц настроек с нижней панелью сохранения.
 * Добавляет padding-bottom и рендерит SettingsSavePanel.
 */
export default function SettingsFormWithPanel({ children, dirty, saving, onSave }) {
  return (
    <div className="settings-form-with-panel">
      {children}
      <SettingsSavePanel onSave={onSave} saving={saving} dirty={dirty} />
    </div>
  )
}
